import { FC } from 'react'
import cn from 'classnames'
import * as styles from 'components/features/pfm/Counter/Counter.styl'
import Animate from 'rc-animate'

const transitionName = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  leave: styles.leave,
  leaveActive: styles.leaveActive,
}

export type CounterStateProps = {
  count: string
  theme: 'green' | 'golden'
}

export type CounterOwnProps = {
  shape: 'round' | 'square'
  hidden?: boolean
}

export type CounterProps =
  & CounterStateProps
  & CounterOwnProps

export const Counter: FC<CounterProps> = (props) => {
  const { count, hidden, theme, shape } = props

  if (!count || hidden) {
    return null
  }

  const className = cn(styles.counter, styles[theme], styles[shape])

  return (
    <Animate transitionName={ count ? transitionName : undefined }>
      <span className={ className }>
        <span className={ styles.counterText }>
          { count }
        </span>
      </span>
    </Animate>
  )
}
